<template>
  <div class="content_box">
    <van-cell-group>
      <van-cell>
        <van-field v-model="phoneNumber" type="text" label="新的手机号" placeholder="请输入手机号" />
      </van-cell>
      <van-cell>
        <van-field v-model="code" label="验证码" center clearable placeholder="请输入验证码">
          <template #button>
            <div v-if="show" class="querybtn" @click="sendCode">获取验证码</div>
            <div v-else>{{times}}s</div>
          </template>
        </van-field>
      </van-cell>
    </van-cell-group>
    <div class="recharge_btn" @click="updatePhoneNumber">确定</div>
  </div>
</template>

<script>
import { updatePhoneNumber,sendCodeBeforeResetPassword } from "@/api/user.js";
import Vue from "vue";
import { Field } from "vant";
import { Cell, CellGroup, Button } from "vant";
import { Notify } from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);
export default {
  data() {
    return {
      code: "",
      phoneNumber: "",
      show: true,
      times: 60,
    };
  },
  created() {
  },
  methods: {
    sendCode() {
      if (!this.phoneNumber) {
      Notify({ type: "danger", message: "请先输入手机号！" });
      return;
      }
      sendCodeBeforeResetPassword(this.phoneNumber).then(res => {
         if (res.data.status == 200) {
          Notify({ type: "success", message: "验证码发送成功！" });
          this.getCode();
         } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });

    },
    getCode() {
      this.show = false;
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          this.times = 60;
          this.show = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    updatePhoneNumber() {
      if (!this.phoneNumber) {
        Notify({ type: "danger", message: "请先输入手机号！" });
        return;
      }
      if (!this.code) {
        Notify({ type: "danger", message: "请先输入验证码！" });
        return;
      }

      updatePhoneNumber({
        phoneNumber: this.phoneNumber,
        code: this.code
      }).then(res => {
        if (res.data.status == 200) {
          Notify({ type: "success", message: "更换手机号成功" });
          this.$router.push({
            path: `/tcmr/user`
          });
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    }
  }
};
</script>

<style scoped>
.changeStatus {
  font-size: 0.24rem;
  float: right;
  padding: 0.3rem 0.5rem;
}
.nopwd {
  margin-top: 10px;
  font-size: 0.24rem;
}
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0.2rem 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
</style>